export default __webpack_public_path__ + "static/media/weather.ff49e24e.svg";